import React from "react";

export const LangContextDefault = "se";

export const LangContext = React.createContext([LangContextDefault, (lang) => {}]);


export default LangContext;